import { Component, OnInit, OnDestroy, HostListener, } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  slideInAnimation,
  fader,
  slider,
  transformer,
  stepper,
} from './animations';
// import { trigger, transition, useAnimation } from '@angular/animations';
import { Router, NavigationEnd } from '@angular/router';
// import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { CanonicalService } from './shared/canonical.service';
import {
  NgcCookieConsentService,
  NgcInitializeEvent,
  NgcStatusChangeEvent,
  NgcNoCookieLawEvent,
} from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    // trigger('slide',  [ transition('ios => android', useAnimation(moveFromBottomFade))]),
    // slideInAnimation,
    fader,
    // transformer,
    // stepper
  ],
})
export class AppComponent implements OnInit, OnDestroy {

  //keep refs to subscriptions to be able to unsubscribe later
  popupOpenSubscription?: Subscription;
  popupCloseSubscription?: Subscription;
  initializeSubscription?: Subscription;
  statusChangeSubscription?: Subscription;
  revokeChoiceSubscription?: Subscription;
  noCookieLawSubscription?: Subscription;

  title =
    'MProtectt is Mobile AntiVirus App with smart features of Breach report, Memory Booster, Battery Booster';
  constructor(
    private router: Router,
    private canonicalService: CanonicalService,
    private ccService: NgcCookieConsentService
  ) { }

  slides = [
    { img: 'http://placehold.it/350x150/000000' },
    { img: 'http://placehold.it/350x150/111111' },
    { img: 'http://placehold.it/350x150/333333' },
    { img: 'http://placehold.it/350x150/000000' },
    { img: 'http://placehold.it/350x150/111111' },
    { img: 'http://placehold.it/350x150/333333' },
    { img: 'http://placehold.it/350x150/666666' },
  ];
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: true,
  };

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }
  getState(outlet: RouterOutlet) {
    return outlet.activatedRouteData.state;
  }

  addSlide() {
    this.slides.push({ img: 'http://placehold.it/350x150/777777' });
  }

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit() { }

  breakpoint() { }

  afterChange() { }

  beforeChange() { }
  ngOnInit() {
    // subscribe to cookieconsent observables to react to main events
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
      console.log('popupOpen');
    });

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
      console.log('popuClose');
    });

    this.initializeSubscription = this.ccService.initialize$.subscribe(
      (event: NgcInitializeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
        console.log(`initialize: ${JSON.stringify(event)}`);
      }
    );

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
        console.log(`statusChange: ${JSON.stringify(event)}`);
      }
    );

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
        console.log(`revokeChoice`);
      }
    );

    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
        console.log(`noCookieLaw: ${JSON.stringify(event)}`);
      }
    );

    // this.loadScript('http://www.some-library.com/library.js');
    this.canonicalService.setCanonicalURL();
    this.loadScript('assets/js/main.js');
    this.router.events.forEach((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    AOS.init({
      duration: 3000
    });
    setTimeout(() => {
      AOS.refresh();
    }, 500);
    // this.titleService.setTitle(this.title);
    // this.metaTagService.addTags([
    //   {
    //     name: 'keywords',
    //     content: 'Protectt.ai MProtectt, App protectt, Real Time Protectt',
    //   },
    //   { name: 'robots', content: 'index, follow' },
    //   { name: 'author', content: 'Protectt.ai Labs' },
    //   { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    //   { name: 'date', content: '01-06-2021', scheme: 'DD-MM-YYYY' },
    //   { charset: 'UTF-8' },
    // ]);

    $(document).ready(function () {
      $('.avTile').hover(function () {
        $('.avFeature').toggleClass('active');
        $('.mainFeature').toggleClass('active');
      });
      $('.firewallTile').hover(function () {
        $('.firewallFeature').toggleClass('active');
        $('.mainFeature').toggleClass('active');
      });
      $('.backupTile').hover(function () {
        $('.backupFeature').toggleClass('active');
        $('.mainFeature').toggleClass('active');
      });
      $('.vulnerabilitiesTile').hover(function () {
        $('.vulnerabilitiesFeature').toggleClass('active');
        $('.mainFeature').toggleClass('active');
      });
      $('.spamfilterTile').hover(function () {
        $('.spamfilterFeature').toggleClass('active');
        $('.mainFeature').toggleClass('active');
      });
    });
  }
  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }
  ngOnDestroy() {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription?.unsubscribe();
    this.popupCloseSubscription?.unsubscribe();
    this.initializeSubscription?.unsubscribe();
    this.statusChangeSubscription?.unsubscribe();
    this.revokeChoiceSubscription?.unsubscribe();
    this.noCookieLawSubscription?.unsubscribe();
  }
}
